export default __webpack_public_path__ + "static/media/langer_bus_seite_weiß.bff12440.jpg";